const jobs = {
  reservations: 'הזמנות',

  btnCreate: 'הוסף',
  btnRoute: 'מסלול',

  createHeaderTitle: 'הוסף',
  updateHeaderTitle: 'עדכן',

  import: {
    title: 'העלאת הזמנות',
  },

  toast: {
    error: {
      create: {
        badResponse: 'אירעה שגיאה בעת יצירת ההזמנה',
      },
      edit: {
        badResponse: 'אירעה שגיאה בעת עדכון ההזמנה',
      },
      find: {
        badResponse: 'Could not find shuttles ',
      },
    },

    success: {
      create: {
        default: 'ההזמנה נוצרה בהצלחה',
      },

      update: {
        default: 'ההזמנה עודכנה בהצלחה',
      },
    },

    group: {
      success: 'ההזמנה קובצה בהצלחה',
      failure: {
        privateOnly: 'לא הצלחנו לקבץ את ההזמנות הללו מכיוון שחלקן מוגדרות כפרטיות בלבד.',
        unknownError: 'בקיבוץ ההזמנות הללו נתקלנו בבעיה בלתי צפויה. אנא נסה שוב או פנה לתמיכה שלנו.',
      },
    },

    ungroup: {
      success: 'ההזמנה הופרדה בהצלחה',
    },

    blockWaitAndReturn: {
      success: 'ההזמנה הושבתה בהצלחה מ"המתן וחזור"',
    },

    unblockWaitAndReturn: {
      success: 'ההזמנה הופעלה בהצלחה ל"המתן וחזור"',
    },
  },

  toolTip: {
    routingCancelJob: 'לפחות עבודה אחת אינה במצב חדש',
    atLeastOneLockedJob: 'לפחות עבודה אחת נעולה',
    noPermission: ' No permission',
    dataSync: 'סנכרון הנתונים פועל',
  },

  create: {
    confirmButtonText: 'שמור',
    successModal: {
      header: 'הצלחה',
      body: 'ההזמנה נוצרה!',
    },

    errorModal: {
      header: 'אירעה שגיאה',
      body: 'לא ניתן ליצור הזמנה',
    },

    confirmationModal: {
      header: 'אשר הזמנה',
      subtitle: 'אנא קרא את התסריט שלהלן - מילה במילה - אל תמהר!!!',
      content:
        'We have {{service}} booking for {{seats}} person\nOn {{date}} from {{from}} to {{to}}\n\nIs That correct? Great!\n\nPrice is ${{price}}\nThank you for calling {{company}}',
      table: {
        headers: {
          details: 'פרטי נסיעה',
          fare: 'תעריף',
        },

        fields: {
          details: {
            pickAdrs: 'כתובת איסוף',
            dropAdrs: 'כתובת הורדה',
            pickTime: 'שעת איסוף',
            seats: 'מבוגרים',
          },
          fare: {
            service: 'שירות',
          },
        },
      },
      bottomLine: 'מחיר כולל',
    },
    serviceTable: {
      columns: {
        name: 'שם',
        maxPax: 'מקסימום נוסעים',
      },
    },
    duplicateJobsModal: {
      body: 'שימו לב שישנן הזמנות אחרות עם אותם פרטים בדיוק.\nהאם ברצונך להמשיך?',
      btnConfirm: 'כן',
      btnClose: 'לא',
    },
  },

  payments: {
    table: {
      headers: {
        createdBy: 'נוצר',
        email: 'אימייל משתמש יוצר',
        amount: 'סכום',
        type: 'סוג',
        ccMasked: 'כרטיס אשראי מוסתר',
        status: 'סטטוס',
        refNum: 'Ref Num ',
      },
    },

    paymentsDetails: {
      title: 'פרטים',

      status: {
        charged: 'חויב:',
        pending: 'ממתין:',
        declined: 'נדחה:',
        variance: 'שונות:',
      },
    },

    addPaymentForm: {
      title: 'הוסף תשלום',

      fields: {
        amount: 'סכום',
        paymentType: 'סוג תשלום',
        cardNum: 'מספר אשראי',
        cardExp: 'תוקף',
        cvv: 'CVV',
        paymentOptions: {
          select: 'בחר',
          credit: 'אשראי',
          directBill: 'חיוב ישיר',
          card: 'כרטיס',
          expDate: 'תאריך תפוגה',
        },
      },

      validations: {
        price: 'המחיר חייב להיות גדול מאפס',
      },

      confirmPaymentBtn: 'אשר תשלום',
      modalSuccess: {
        header: 'הצלחה!',
        body: 'התשלום הצליח!',
      },

      modalError: {
        header: 'אירעה שגיאה!',
        body: 'התשלום נכשל\nאנא נסה שוב',
      },
    },
  },

  update: {
    title: 'הזמנה #{{id}}',
    confirmButtonText: 'שמור',

    successModal: {
      header: 'הצלחה',
      body: 'ההזמנה עודכנה!',
    },

    errorModal: {
      header: 'אירעה שגיאה',
      body: 'לא ניתן לעדכן הזמנה',
    },

    formTabs: {
      summary: 'סיכום',
      edit: 'ערוך',
      payments: 'תשלומים',
      notes: 'הערות',
      history: 'היסטוריה',
    },

    summary: {
      driver: 'נהג',
      vehicle: 'רכב',
      tripId: 'מזהה נסיעה',
      tripStatus: 'סטטוס נסיעה',
      RPTime: 'זמן איסוף מבוקש',
      MPTime: 'זמן איסוף ע"פ מובקס',
      PETA: 'זמן הגעה משוער לאיסוף',
      PR: 'איסוף דווח (נהג)',
      DR: 'הורדה דווחה (נהג)',
      empty: 'לא זמין',
      notAssigned: 'לא צוות',
      notRouted: 'לא הופק',
      attributes: 'מאפיינים',
      noShow: 'לא הופיע',
      supplier: 'ספק',
    },
    jobNotSupported: 'סוג ההזמנה אינו נתמך',
  },

  bulk: {
    select: 'בחר',
    toasts: {
      createdSuccessfully: 'ההזמנה נוצרה!',
    },

    errorModal: {
      header: 'אירעה שגיאה',
      body: 'לא ניתן ליצור הזמנה',
    },

    table: {
      direction: {
        to: 'פיזור',
        from: 'איסוף',
        both: 'איסוף & פיזור',
      },
    },

    direction: {
      label: 'כיוון',
      to: 'אל',
      from: 'מ-',
      both: 'שניהם',
    },

    dateMode: {
      automated: 'תזמון אוטומטי',
      manual: 'בחירת זמן ידנית',
    },

    form: {
      information: {
        details: {
          header: 'פרטי הזמנה',
          messageDublication: 'כרטיס עם אותם ערכים כבר קיים',
          fields: {
            shift: 'משמרת',
            from: 'מ-',
            to: 'אל',
            fromDate: 'מתאריך',
            toDate: 'עד תאריך',
            weekDays: 'ימי השבוע',
            fromHour: 'משעה',
            toHour: 'עד שעה',
            requestPickup: 'זמן איסוף מבוקש',
            requestDropoff: 'זמן הורדה מבוקש',
            direction: 'בחר כיוון',
            dateMode: 'העדפת זמן',
            btnAddDetails: 'הוסף אפשרויות נוספות +',
            btnRemoveDetails: 'הסר',
          },
        },
        locations: {
          header: 'מיקומים',
          fields: {
            locations: 'בחר מיקום',
          },
        },
        dateMode: {
          header: 'העדפת זמן',
          label: 'בחר העדפת זמן',
        },
      },
    },
  },

  routeSummary: {
    reservations: 'הזמנות',
    trips: 'נסיעות',
    assigned: 'צוות',
    unassigned: 'ללא ציוות',
    tripsAssigned: 'נסיעות שצוותו',
    vehicles: 'רכבים',
    workingTime: 'זמן עבודה',
    drivingTime: 'זמן נהיגה',
    miles: 'מיילים',
    routingProcessTime: 'זמן תהליך הפקה',
  },

  headerButtons: {
    create: {
      new: 'חדש',
      quick: 'מהיר',
      bulk: 'כמות גדולה',
      shuttle: 'שאטל',
      import: 'ייבא',
      normal: 'רגיל',
      schoolBooking: 'הזמנת בית ספר',
      workplaceBooking: 'הזמנת מקום עבודה',
    },

    import: 'ייבא',

    route: {
      route: 'מסלול',
      routeAndAssign: 'הפק & צוות',
    },

    moreActions: {
      button: 'עוד',
      options: {
        cancelModal: {
          title: 'בטל הזמנות',
          reasonInputPlaceholder: 'אנא הזן סיבת ביטול.',
          contentSingular: 'אתה עומד לבטל הזמנה אחת.',
          contentPlural: 'אתה עומד לבטל {{count}} הזמנות.',
          confirmButton: 'אשר',
          success: 'ההזמנות בוטלו בהצלחה',
        },
        deleteModal: {
          title: 'מחק הזמנות',
          body: 'אתה עומד למחוק {{count}} הזמנות',
          success: 'ההזמנות נמחקו בהצלחה',
        },
        releaseRouting: {
          label: 'שחרר הפקה',
        },
      },
    },
  },

  advancedRoutingModal: {
    all: 'הכל',
    RouteBodyText: 'אתה עומד לנתב {{num}} הזמנות.',
    RouteAssignBodyText: 'אתה עומד להפיק ולצוות {{num}} הזמנות.',
    advancedSettings: 'מתקדם',
    noJoin: 'ללא הצטרפות',
    joinOptions: {
      noJoin: 'ללא הצטרפות',
      tryJoin: 'נסה להצטרף',
      onlyJoin: 'הצטרף בלבד',
    },
    clusterSettings: 'הגדרות אשכול',
    assignSettings: 'הגדרות ציוותי נהגים',
    routeJobs: 'נתב הזמנות',
    routeAssignJobs: 'הפק וצוות הזמנות',
    advancedRoutingSettings: 'הגדרות הפקה מתקדמות',
    mainParameters: 'הגדרות מסלול',
    ratio: 'יחס',
    ratioInfo: '1.5 פירושו שמשך הזמן של אדם היושב ברכב לא יעלה על 150% מהזמן שהיה מבלה בנהיגה לבד.',
    pax: 'מקסימום נוסעים',
    paxInfo: 'מספר מקסימלי של מושבים לנסיעה',
    maxDuration: 'משך מקסימלי',
    maxDurationInfo: 'משך מקסימלי של נסיעה',
    maxStops: 'מקסימום עצירות',
    maxStopsInfo: 'מקסימום עצירות בנסיעה',
    pickSeconds: 'זמן עלייה',
    pickSecondsInfo: 'זמן העלייה המחושב של העבודה. משך הנסיעה הכולל יוארך. זמנים יתווספו למערך "המתנה" עבור עצירה זו.',
    dropSeconds: 'זמן הורדה',
    dropSecondsInfo: 'זמן ההורדה המחושב של העבודה. משך הנסיעה הכולל יוארך. זמנים יתווספו למערך "המתנה" עבור עצירה זו.',
    pickGapAfter: 'איחור מקסימלי',
    pickGapAfterInfo: 'זמן האיסוף של עבודה לא יהיה יותר מ-30 דקות לאחר זמן האיסוף של עבודה אחרת.',
    pickGapBefore: 'הקדמה מקסימלית',
    pickGapBeforeInfo: 'זמן האיסוף של עבודה לא יקדים את זמן האיסוף של עבודה אחרת ביותר מ-30 דקות.',
    airKMPH: 'מהירות אוויר בקמ"ש',
    airKMPHInfo: 'פנה לתמיכה',
    allowLate: 'אפשר איחור',
    allowLateInfo: 'פנה לתמיכה',
    maxPrice: 'מחיר מקסימלי',
    maxPriceInfo: 'פנה לתמיכה',
    maxTrips: 'מקסימום נסיעות',
    maxTripsInfo: 'תמיכה במקסימום נסיעות',
    shiftMaxMinutes: 'מקסימום דקות למשמרת',
    shiftMaxMinutesInfo: 'פנה לתמיכה',

    routeTemplates: 'תבניות - הפקות',
    assignTemplates: 'תבניות - ציוותים',

    form: {
      validation: {
        mustBeHigher: 'חייב להיות {{val}} או גבוה יותר',
      },
    },
  },

  clusters: {
    clusterRadius: 'קוטר אשכול',
    snapTo: 'מצב',
    none: 'ללא',
    both: 'שניהם',
    to: 'אל',
    from: 'מ-',
    address: 'כתובת',
    bus: 'תחנת אוטובוס',
  },

  forms: {
    header: {
      createNewRservationTitle: 'הזמנה חדשה',
      updateReservationTitle: 'הזמנה',

      createNormalRservation: {
        subTitle: 'רגיל',
      },

      createQuickRservation: {
        subTitle: 'מהיר',
      },

      createShuttleRservation: {
        subTitle: 'שאטל',
      },
    },

    roundTrip: 'נסיעה הלוך ושוב',
    oneWay: 'נסיעה בכיוון אחד',
    information: {
      details: {
        header: 'פרטי פרופיל',
        fields: {
          site: 'אתר',
          profile: 'פרופיל',
        },
      },
      jobDetails: {
        flightTypes: {
          international: 'בינלאומי',
          domestic: 'פנים-ארצי',
          customerRequest: 'בקשת לקוח',
        },
        fareBreakdown: 'פירוט תעריף',
      },
      linkedPassengers: {
        header: 'נוסעים מקושרים',
        searchPlaceholder: 'חיפוש',
      },
      reservationDetails: {
        header: 'פרטי הזמנה',
        fields: {
          from: 'מ-',
          to: 'אל',
          terminal: 'טרמינל',
          seats: 'מושבים',
          checkedBags: 'מזוודות שנבדקו',
          switchADA: 'עדה',
          wheelchair: 'כיסא גלגלים',
          adults: 'מבוגרים',
          infants: 'תינוקות',
          carryon: 'תיק יד',
        },
        clearBtn: 'נקה',
      },
      flightDetails: {
        header: 'פרטי טיסה',
        flightAirline: 'חברת תעופה',
        flightNumber: 'מספר טיסה',
        scheduledFlightTime: 'זמן טיסה מתוכנן',
        actualFlightTime: 'זמן טיסה בפועל',
        flightStatus: 'סטטוס טיסה',
      },
      caregiverInformation: {
        header: 'מידע על מטפל',
        fields: {
          firstName: 'שם פרטי',
          lastName: 'שם משפחה',
          address: 'כתובת',
          phone: 'טלפון',
        },
      },
      serviceAndTime: {
        header: 'שירות וזמן',
        fields: {
          scheduleBy: 'תזמן לפי',
          dateTime: 'תאריך ושעה',
          service: 'שירות',
          switchRecurring: 'חוזר',
          attributes: 'מאפיינים',
          repeatEvery: 'חזור כל',
          ends: 'מסתיים',
          never: 'לעולם לא',
          on: 'בתאריך',
          after: 'לאחר',
          occurrences: 'התרחשויות',
        },
        buttons: {
          now: 'עכשיו',
        },
      },
      personalInfo: {
        header: 'מידע אישי',
        fields: {
          email: 'אימייל',
          fullName: 'שם מלא',
          firstName: 'שם פרטי',
          lastName: 'שם משפחה',
          phone: 'טלפון',
          address: 'כתובת',
          specialIdentifier: 'מזהה מיוחד',
        },
      },
      billingInfo: {
        sameAsPersonalInformation: 'זהה למידע האישי',
        header: 'מידע לחיוב',
        fields: {
          country: 'מדינה',
          state: 'מדינה',
          zip: 'מיקוד',
        },
      },
      payments: {
        header: 'תשלומים',
        fields: {
          price: 'מחיר',
          paymentSelect: {
            header: 'סוג תשלום',
            options: {
              credit: 'אשראי',
              directBill: 'חיוב ישיר',
            },
          },
          cardNum: 'מספר אשראי',
          cardExp: 'תוקף',
          cvv: 'CVV',
        },
      },
      additionalFields: {
        header: 'שדות נוספים',
        fields: {
          driver: 'נהג',
          car: 'רכב',
          waitMinutes: 'דקות המתנה',
        },
      },
      notes: {
        header: 'הערות',
      },
      profile: {
        header: 'פרופיל',
        label: 'בחר פרופיל',
      },
      passengers: {
        header: 'מידע אישי',
        label: 'בחר נוסעים',
      },
      attributes: {
        header: 'מאפיינים',
        label: 'בחר מאפיינים',
      },
      supplier: {
        header: 'ספק',
      },
    },
    validations: {
      unit: {
        required: 'פרופיל נדרש',
      },
      amount: {
        required: 'סכום נדרש',
      },
      from: {
        required: 'מאת נדרש',
      },
      direction: {
        required: 'כיוון נדרש',
      },
      to: {
        required: 'אל נדרש',
      },
      type: {
        required: 'נדרש',
      },
      email: {
        message: 'הזן אימייל תקין',
        required: 'אימייל נדרש',
      },
      firstName: {
        conditions: {
          min: 'שם פרטי צריך להיות לפחות 2 תווים',
          max: 'שם פרטי יכול להכיל עד 30 תווים',
        },
        required: 'שם פרטי נדרש',
      },
      lastName: {
        conditions: {
          min: 'שם משפחה צריך להיות לפחות 2 תווים',
          max: 'שם משפחה יכול להכיל עד 30 תווים',
        },
        required: 'שם משפחה נדרש',
      },
      phone: {
        message: 'מספר טלפון לא תקין',
        required: 'מספר טלפון נדרש',
      },
      price: {
        message: 'המחיר חייב להיות מספר',
        required: 'מחיר נדרש',
      },
      flightTerminal: {
        required: 'טרמינל טיסה נדרש',
      },
      adults: {
        required: 'מבוגרים נדרשים',
      },
      seats: {
        required: 'מושבים נדרשים',
      },
      infants: {
        required: 'תינוקות נדרשים',
      },
      carryon: {
        required: 'תיק יד נדרש',
      },
      paymentType: {
        required: 'סוג תשלום נדרש',
      },
      cardNum: {
        required: 'מספר כרטיס נדרש',
      },
      cardExp: {
        required: 'תוקף כרטיס נדרש',
      },
      cvv: {
        required: 'CVV נדרש',
      },
      profile: {
        required: 'פרופיל נדרש',
      },
      fare: {
        required: 'תעריף נדרש',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'אשר',
        update: 'אשר',
        delete: 'מחק',
      },
    },
  },

  table: {
    footer: {
      totalSeats: 'סה"כ מושבים: {{seats}}',
    },
    actions: {
      delete: 'מחק',
      export: 'ייצא',
      route: 'מסלול',
      cancel: 'בטל',
      routeAndAssign: 'הפק & צוות',
      group: 'קבץ',
      ungroup: 'בטל קיבוץ',
      blockWaitAndReturn: 'השבת המתן וחזור',
      unblockWaitAndReturn: 'הפעל המתן וחזור',
      releaseRouting: 'שחרור הפקה',
      sendToBid: 'שלח להצעה',
      estimateWillCalls: 'הערכת Will Calls',
      tooltips: {
        estimateWillCallsDisabled: 'לפחות משימה אחת אינה במצב “חדש”'
      }
    },
    cells: {
      car: {
        none: 'אין רכבים',
      },
      driver: {
        none: 'אין נהג',
      },
      supplier: {
        none: 'אין ספקים',
      },
    },
    filters: {
      status: 'סטטוס',
      profile: 'פרופילים',
      supplier: 'ספקים',
      attributes: 'מאפיינים',
      flightNumber: 'מספר טיסה',
      airline: 'חברת תעופה',
      flightStatus: 'סטטוס טיסה',
      drivers: 'נהגים',
      vehicles: 'רכבים',
      from: 'מ-',
      to: 'אל',
      locations: 'תחנות',
      airportLocations: 'מיקומי שדה תעופה',
      areas: 'אזורים',
    },
    headers: {
      externalID: 'מזהה חיצוני',
      flightInfo: 'פרטי טיסה',
      id: 'מזהה',
      io: 'כניסה ויציאה',
      returnTrip: 'נסיעה חזור',
      legA: 'קטע א',
      legB: 'קטע ב',
      seats: 'מושבים',
      driver: 'נהג',
      vehicle: 'רכב',
      from: 'מ-',
      to: 'אל',
      supplier: 'ספק',
      statusAndId: 'מזהה',
      passenger: 'נוסע',
      indicators: 'אינדיקטורים',
      attributes: 'מאפיינים',
      extendUntilDate: 'המתן עד',
      date: 'תאריך',
      phone: 'טלפון',
      flightNumber: 'מספר טיסה',
      email: 'אימייל',
      service: 'שירות',
      airline: 'חברת תעופה',
      scheduledFlightTime: 'זמן טיסה מתוכנן',
      actualFlightTime: 'זמן טיסה בפועל',
      flightStatus: 'סטטוס טיסה',
      price: 'מחיר',
      profile: 'פרופיל',
      areas: 'אזורים',
      distance: 'מרחק',
      duration: 'משך',
      cost: 'עלות',
    },
    statuses: {
      new: 'חדש',
      onHold: 'בהמתנה',
      canceled: 'בוטל',
      routing: 'בהפקה',
      routed: 'נותב',
      picked: 'נאסף',
      dropped: 'הורד',
      noshow: 'לא הופיע',
    },
    labels: {
      grouped: 'מקובץ',
      waitAndReturn: 'המתן וחזור',
      roundTrip: 'דו-כיווני',
      arrivalTime: {
        label: 'זמן הגעה',
        tooltip: 'זמן הגעה',
      },
    },
  },

  assignVehiclesDrivers: {
    routeSummaryModal: {
      header: 'סיכום מסלול',
    },
  },

  checkRouteStatus: {
    routeSummaryModal: {
      header: 'סיכום מסלול',
    },
  },
  shuttleReservation: {
    create: {
      confirmButtonText: 'הזמן',
    },

    form: {
      information: {
        recurring: {
          header: 'חוזר',
        },
        personalInformation: {
          header: 'פרטים אישיים',
          fields: {
            firstName: 'שם פרטי',
            lastName: 'שם משפחה',
            email: 'אימייל',
            phone: 'טלפון',
          },
        },
        paymentOption: {
          header: 'אפשרויות תשלום',
          fields: {
            paymentType: 'סוג תשלום',
            cardNum: 'מספר כרטיס',
            cardExp: 'תוקף',
            cvv: 'CVV',
            rate: 'תעריף',
            amount: 'סכום',
            fare: 'תעריף',
          },
          paymentTypes: {
            free: 'חינם',
            opuscard: 'כרטיס OPUS',
            cashonboard: 'מזומן על הסיפון',
            creditcard: 'כרטיס אשראי',
            correspondance: 'התכתבות',
          },
          rateTypes: {
            ordinary: 'סכום מזומן',
            reduced: 'מופחת',
          },
        },
        bookingDetails: {
          header: 'פרטי הזמנה',
          fields: {
            supplier: 'ספק',
            date: 'תאריך',
            hour: 'שעה',
            area: 'אזור',
            direction: 'כיוון',
            operationHours: 'שעות פעילות',
            line: 'שאטל',
            pickup: 'איסוף',
            dropoff: 'הורדה',
            seats: 'מושבים',
          },
        },
      },
      validations: {
        drivers: {
          required: 'נדרשים נהגים',
        },
        area: {
          required: 'אזור נדרש',
        },
        direction: {
          required: 'כיוון נדרש',
        },
        unit: {
          required: 'יחידה נדרשת',
        },
        supplier: {
          required: 'ספק נדרש',
        },
        driver: {
          required: 'נהג נדרש',
        },
        start: {
          required: 'תאריך התחלה נדרש',
        },
        end: {
          required: 'תאריך סיום נדרש',
        },
        firstName: {
          required: 'שם פרטי נדרש',
        },
        lastName: {
          required: 'שם משפחה נדרש',
        },
        email: {
          required: 'אימייל נדרש',
        },
        phone: {
          required: 'טלפון נדרש',
        },
        date: {
          required: 'תאריך נדרש',
        },
        line: {
          required: 'שאטל נדרש',
        },
        hour: {
          required: 'שעה נדרשת',
        },
        from: {
          required: 'מאת נדרש',
        },
        fromLat: {
          required: 'קו רוחב של המוצא נדרש',
        },
        fromLon: {
          required: 'קו אורך של המוצא נדרש',
        },
        to: {
          required: 'אל נדרש',
        },
        toLat: {
          required: 'קו רוחב של היעד נדרש',
        },
        toLon: {
          required: 'קו רוחב של היעד נדרש',
        },
        seats: {
          required: 'מושבים נדרשים',
          conditions: {
            min: 'מושבים צריכים להיות גבוהים מ-{{min}}',
          },
        },
        paymentOptions: {
          required: 'אפשרויות תשלום נדרשות',
          paymentType: {
            required: 'סוג תשלום נדרש',
          },
          data: {
            required: 'נתוני תשלום נדרשים',
            opusCard: {
              minLength: 'חייב להיות בדיוק 12 תווים',
            },
          },
        },
      },
    },

    toasts: {
      notFound: 'לא נמצא שאטל ליום זה!',
    },
  },
  duplicatedCreationModal: {
    header: 'הזמנה כפולה: להמשיך?',
    body: 'ישנן הזמנות אחרות עם פרטים זהים. האם ברצונך להמשיך ביצירת ההזמנה?',
  },

  duplicatedUpdatingModal: {
    header: 'הזמנה כפולה: להמשיך?',
    body: 'ישנן הזמנות אחרות עם פרטים זהים. האם ברצונך להמשיך בעדכון ההזמנה?',
  },

  modals: {
    groupModal: {
      header: 'קבץ הזמנות',
      body: 'אתה עומד לקבץ {{count}} הזמנות',
      btnConfirm: 'אשר',
    },
    confirmGroupModal: {
      header: 'קבץ הזמנות',
      body: 'אחת מההזמנות כבר קובצה. האם ברצונך להמשיך ולקבץ אותה מחדש?',
    },
    unGroupModal: {
      header: 'בטל קיבוץ הזמנות',
      body: 'אתה עומד לבטל קיבוץ של {{count}} הזמנות',
      btnConfirm: 'אשר',
    },
    blockedGroupModal: {
      header: 'קיבוץ/ביטול קיבוץ הזמנות',
      body: 'Group/Ungroup action is only allowed on bookings with a "חדש" status',
      btnConfirm: 'סגור',
    },
  },
};

export default jobs;
